import { formatDateMoment, setNumberWithPoint } from 'utils/utils'
import { Link } from 'react-router-dom'

export const TABLE_USER_MEMBERSHIP = {
    name: 'User Membership',
    column: [
        {
            name: 'Nama',
            key: 'name',
            render: ({ item }) => (
                <Link to={`/loyalty-program/user-membership/detail?userId=${item?.id}`}>
                    <div className={'font-medium text-blue-90 hover:font-bold hover:underline capitalize'}>
                        {item?.name}
                    </div>
                </Link>
            ),
        },
        {
            name: 'Email',
            key: 'email',
        },
        {
            name: 'No. Telepon',
            key: 'phone_number',
        },
        {
            name: 'Total Point',
            key: 'total_point',
            render: ({ value }) => <div>{value >= 0 ? `${setNumberWithPoint(value)} Point` : '-'}</div>,
        },
        {
            name: 'Type Member',
            key: 'origin',
            render: ({ value }) => <div>{value === 'online' ? 'Website' : 'Offline Store'}</div>,
        },
        {
            name: 'Created At',
            key: 'created_at',
            render: ({ value }) => <div>{formatDateMoment(value, 'DD/MM/YYYY HH:mm')}</div>,
        },
    ],
}

export const INITIAL_DATA_FILTER = {
    search: '',
    page: 1,
    limit: 20,
    order_by: 'created_at',
    order_type: 'desc',
}

export const INIT_FILTER = {
    types: [],
}

export const FILTER_USER_MEMBERSHIP = [
    {
        title: 'Tipe Member',
        key: 'types',
        list: [
            {
                name: 'Website',
                value: 'online',
            },
            {
                name: 'Offline Store',
                value: 'offline',
            },
        ],
    },
]

export const SORT_USER_MEMBERSHIP = [
    {
        label: 'Sort By Total Point Desc',
        key: 'total_point-desc',
        name: 'sort-user',
    },
    {
        label: 'Sort By Total Point Asc',
        key: 'total_point-asc',
        name: 'sort-user',
    },
    {
        label: 'Sort By Created At Desc',
        key: 'created_at-desc',
        name: 'sort-user',
    },
    {
        label: 'Sort By Created At Asc',
        key: 'created_at-asc',
        name: 'sort-user',
    },
    {
        label: 'Sort By Name Desc',
        key: 'name-desc',
        name: 'sort-user',
    },
    {
        label: 'Sort By Name Asc',
        key: 'name-asc',
        name: 'sort-user',
    },
]
